<template>
  <div>
    <div v-if="popupOpen" class="absolute z-[999] top-0 right-0 left-0 bottom-0 bg-white dark:bg-primary-dark/30 backdrop-blur flex flex-col justify-center" >
      <div class="relative w-full max-w-3xl m-auto min-h-[300px] flex flex-col bg-white dark:bg-primary-dark border-4 border-accent overflow-y-scroll scrollbar-hide">

        <span @click="closePopup" class="absolute text-white flex items-center leading-none right-4 top-4 lg:right-4 cursor-pointer uppercase text-sm" >
          <svg-vue icon="times" class="fill-current h-4 w-4 mr-2"></svg-vue>
          snooze
        </span>

        <div class="flex-grow lg:h-full w-full flex flex-col justify-center items-center px-4 md:px-8 py-20 lg:py-12">
          <h2 class="font-medium text-center leading-8 text-2xl lg:text-4xl dark:text-accent-light" tabindex="0">Finding What You Need?</h2>
          <p class="text-white md:text-lg mb-8 text-center ">Register below so we can help.</p>
            <signup-form
              :nonce="this.nonce"
              :user-ip="this.userIp"
              :user-agent="this.userAgent"
              :referrer="this.referrer"
              @submit="extendSession(9999999999999999)"
            >
              <p class="text-white md:text-lg mb-8 text-center ">Thanks for registering!</p>
            </signup-form>
        </div>

      </div>
    </div>
  </div>
</template>
<script>
import SignupForm from './SignupForm.vue'

export default {
  name: "Popup",

  components: {
    SignupForm
  },

  props: {
    popupId: {
      type: String,
      default: "popup"
    },
    timeoutHours: {
      type: Number,
      default: 0,
    },
    timeout: {
      type: Number,
      default: 600, // 10 minutes (in seconds)
    },
    delay: {
      type: Number,
      default: 0, // instant (in seconds)
    },
    nonce: {
      type: String,
      default: '',
    },
    userIp: {
      type: String,
      default: '',
    },
    userAgent: {
      type: String,
      default: '',
    },
    referrer: {
      type: String,
      default: '',
    },
  },

  data () {
    return {
      popupOpen: this.outsideControl,
      snoozeFor: this.timeout,
      timer: 0,
      snooze: this.delay
    }
  },

  mounted () {

    var paused = window.localStorage.getItem('paused')
    if (paused === null){
      localStorage['paused'] = 'false'
    }

    if(this.timeoutHours > 0){
      this.snoozeFor = this.timeoutHours * 60 * 60
    } else {
      this.snoozeFor = this.timeout
    }

    // Start Timer
    if('timer' in localStorage){
      this.timer = Number(localStorage.timer)
    }
    setInterval(() => this.makeTime(), 1000)

    // save delay in local storage to persist in page changes
    if (!('popup-' + this.popupId + '-delay' in localStorage)) {
      this.snooze = this.timer + this.delay
      localStorage['popup-' + this.popupId + '-delay'] = this.snooze
    } else {
      this.snooze = Number(localStorage['popup-' + this.popupId + '-delay'])
    }

  },

  methods: {
    closePopup () {
      this.popupOpen = false
      localStorage['popup-' + this.popupId] = false
      localStorage['popup-' + this.popupId + '-snoozed'] = this.timer

      // snooze the popup for the delay time
      this.snooze = this.snoozeFor + this.timer
      localStorage['popup-' + this.popupId + '-delay'] = this.snooze

      this.$emit('close')
    },

    makeTime () {
      if(localStorage['paused'] === 'false'){
        this.timer++
        localStorage.timer = this.timer
      }
      if(this.timer > this.snooze) {
        this.openPopup()
      }
    },

    openPopup () {
      this.popupOpen = true
      this.$emit('open')
    },

    extendSession(length){
      this.popupOpen = false
      this.snooze = length
      localStorage['popup-' + this.popupId] = false
      localStorage['popup-' + this.popupId + '-snoozed'] = this.timer
      localStorage['popup-' + this.popupId + '-delay'] = localStorage['timer'] +  this.snooze
    }

  }

}
</script>
